import { CourseTagsData } from "../../models/courseData";

/**
 * Represents the state for course tags in the Redux store.
 */
export interface CourseTagsState {
  courseTags: CourseTagsData[];
  isLoading: boolean;
  error: boolean;
}

/**
 * Action type dispatched when course tags request starts.
 */
export const COURSE_TAGS_REQUEST = "COURSE_TAGS_REQUEST";

/**
 * Action type dispatched when course tags are successfully fetched.
 */
export const COURSE_TAGS_SUCCESS = "COURSE_TAGS_SUCCESS";

/**
 * Action type dispatched when there is an error fetching course tags.
 */
export const COURSE_TAGS_FAILURE = "COURSE_TAGS_FAILURE";

/**
 * Action for initiating a course tags fetch request.
 */
export interface CourseTagsRequestAction {
  type: typeof COURSE_TAGS_REQUEST;
}

/**
 * Action for handling a failed course tags fetch request.
 */
export interface CourseTagsFailureAction {
  type: typeof COURSE_TAGS_FAILURE;
}

/**
 * Action for handling a successful course tags fetch.
 */
export interface CourseTagsSuccessAction {
  type: typeof COURSE_TAGS_SUCCESS;
  data: CourseTagsData[];
}

/**
 * Union type for all possible course tags action types.
 */
export type CourseTagsActionTypes =
  | CourseTagsRequestAction
  | CourseTagsSuccessAction
  | CourseTagsFailureAction;
